import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	spotlightMessage: {
		id: 'insights-next-best-task-filter-button.spotlight.spotlight-message',
		defaultMessage: 'Open your work suggestions panel here',
		description:
			'Informs the user that clicking here will re-open the "work suggestions" panel. Work suggestions refer to tasks that the user can work on next',
	},
});
